<template>
  <el-dialog title="选择目标门店" :visible.sync="visible" width="800px" :close-on-click-modal="false" @close="handleClose">
    <el-tabs v-model="activeTab">
      <el-tab-pane label="选择门店" name="select">
        <el-form :inline="true" :model="searchForm" size="small">
          <el-form-item label="省市">
            <el-cascader
              v-model="searchForm.region"
              :options="regionOptions"
              :props="{ value: 'label', label: 'label' }"
              placeholder="请选择省市"
              clearable
              style="width: 200px"
            ></el-cascader>
          </el-form-item>
          <el-form-item label="门店名称/门店序号">
            <el-input v-model="searchForm.keyword" placeholder="请输入门店名称或门店序号" clearable></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="handleSearch">查询</el-button>
            <el-button @click="handleReset">重置</el-button>
          </el-form-item>
        </el-form>
        <el-table
          ref="shopTable"
          :data="shopList"
          border
          stripe
          height="300"
          v-loading="loading"
          @selection-change="handleSelectionChange"
          row-key="id"
        >
          <el-table-column type="selection" width="55" reserve-selection></el-table-column>
          <el-table-column prop="id" label="门店ID" width="80"></el-table-column>
          <el-table-column prop="xh" label="门店序号" width="100"></el-table-column>
          <el-table-column prop="storename" label="门店名称"></el-table-column>
          <el-table-column prop="city" label="市" width="120"></el-table-column>
          <el-table-column prop="county" label="区" width="120"></el-table-column>
        </el-table>
        <div class="pagination-box">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pagination.page"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="pagination.limit"
            layout="total, prev, pager, next"
            :total="pagination.total"
          ></el-pagination>
        </div>
      </el-tab-pane>
      <el-tab-pane label="批量上传" name="upload">
        <div class="upload-tip">
          <el-button type="text" @click="downloadTemplate">下载Excel模板</el-button>
          <span style="margin-left: 10px; color: #999">门店序号必填；若填写门店名称，需与系统内实际名称一致</span>
        </div>
        <el-upload
          drag
          action="#"
          :auto-upload="false"
          :on-change="handleFileChange"
          :on-remove="handleFileRemove"
          :on-exceed="handleFileExceed"
          :limit="1"
          accept=".xlsx,.xls"
          :file-list="fileList"
          :disabled="parsing"
        >
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
          <div class="el-upload__tip" slot="tip">仅支持xlsx/xls，大小不超过10MB（一次只能上传一个表格）</div>
        </el-upload>
        <el-button
          type="primary"
          size="small"
          class="upload-submit-btn"
          :loading="parsing"
          :disabled="!canUpload"
          @click="parseFile"
        >点击上传</el-button>
        <div v-if="uploadResult.errors.length > 0" class="error-box">
          <div class="error-title">
            <span>共发现 {{ uploadResult.errors.length }} 处异常</span>
            <el-button type="text" @click="downloadErrorReport">下载错误报告</el-button>
          </div>
          <div v-for="(item, index) in uploadResult.errors" :key="index" class="error-item">第{{ item.row }}行：{{ item.message }}</div>
        </div>
      </el-tab-pane>
    </el-tabs>
    <div slot="footer">
      <span style="float: left; line-height: 36px;">已选 {{ selectedCount }} 家门店</span>
      <el-button @click="visible = false">取 消</el-button>
      <el-button type="primary" @click="handleConfirm">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'ShopSelectDialog',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    selectedIds: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      visible: this.value,
      activeTab: 'select',
      searchForm: {
        region: [],
        keyword: ''
      },
      regionOptions: [],
      shopList: [],
      loading: false,
      pagination: {
        page: 1,
        limit: 10,
        total: 0
      },
      selectedShops: [],
      fileList: [],
      uploadResult: {
        errors: [],
        shopIds: [],
        shopNames: []
      },
      tempSelected: [],
      // 是否正在解析（置灰上传控件，避免重复点击）
      parsing: false
    }
  },
  computed: {
    // 底部“已选”数量：批量上传与单独勾选合并为同一份选择，统一以 tempSelected 为准
    selectedCount() {
      return this.tempSelected.length
    },
    // “点击上传”按钮可用条件：已选择文件且上一次解析无异常
    canUpload() {
      return this.fileList.length > 0 && !this.parsing && this.uploadResult.errors.length === 0
    }
  },
  watch: {
    value(val) {
      this.visible = val
      if (val) {
        this.activeTab = 'select'
        this.searchForm = { region: [], keyword: '' }
        this.pagination.page = 1
        this.selectedShops = []
        // 预填已选门店：把外部传入的已选 ID 作为初始选中，避免“已选数量”只统计当前页可见行，
        // 导致已选门店不在第一页时底部数量显示错误、直接确定还会丢失已选门店
        this.tempSelected = Array.isArray(this.selectedIds) ? [...this.selectedIds] : []
        this.uploadResult = { errors: [], shopIds: [], shopNames: [] }
        this.fileList = []
        this.parsing = false
        this.getShopList()
        this.getRegionList()
      }
    },
    visible(val) {
      this.$emit('input', val)
    }
  },
  methods: {
    async getShopList() {
      this.loading = true
      try {
        const params = {
          pagenum: this.pagination.page,
          pagesize: this.pagination.limit,
          query: this.searchForm.keyword,
          // 后端 query2 = cityOrAddress，模糊匹配 city/county/address，取最后一级（市/区）比省名更准
          query2: this.searchForm.region && this.searchForm.region.length > 0
            ? this.searchForm.region[this.searchForm.region.length - 1]
            : ''
        }
        const res = await this.$http.get('/storelist/', { params })
        if (res.data.status === 1 && res.data.data && res.data.data.list) {
          this.shopList = res.data.data.list.map(item => ({
            id: item.pk,
            xh: item.fields.xh,
            storename: item.fields.storename,
            city: item.fields.city,
            county: item.fields.county
          }))
          this.pagination.total = res.data.data.totalCount || 0
          this.$nextTick(() => {
            this.setSelection()
          })
        } else {
          this.$message.error(res.data.msg || '获取门店列表失败')
        }
      } catch (error) {
        console.error('获取门店列表失败:', error)
        this.$message.error('获取门店列表失败')
      } finally {
        this.loading = false
      }
    },
    // 地区级联数据：后端只有 /region/tree，返回 { name, adCode, cities:[{name, adCode, districts:[区名]}] }
    // 需要转成 el-cascader 需要的 { label, value, children } 结构
    async getRegionList() {
      try {
        const res = await this.$http.get('/region/tree')
        if (res.data.status === 0) {
          const provinces = res.data.data || []
          this.regionOptions = provinces.map(p => ({
            label: p.name,
            value: p.name,
            children: (p.cities || []).map(c => ({
              label: c.name,
              value: c.name,
              children: (c.districts || []).map(d => ({ label: d, value: d }))
            }))
          }))
        }
      } catch (error) {
        console.error('获取地区列表失败:', error)
      }
    },
    setSelection() {
      if (!this.$refs.shopTable) return
      this.shopList.forEach(row => {
        const isSelected = this.selectedIds.includes(row.id) || this.tempSelected.includes(row.id)
        this.$refs.shopTable.toggleRowSelection(row, isSelected)
      })
    },
    handleSearch() {
      this.pagination.page = 1
      this.getShopList()
    },
    handleReset() {
      this.searchForm = { region: [], keyword: '' }
      this.pagination.page = 1
      this.getShopList()
    },
    handleSizeChange(val) {
      this.pagination.limit = val
      this.pagination.page = 1
      this.getShopList()
    },
    handleCurrentChange(val) {
      this.pagination.page = val
      this.getShopList()
    },
    handleSelectionChange(selection) {
      // 跨页选择：以选中行的完整信息为准（element 在 reserve-selection 下会把跨页已选行一并带来）
      const currentIds = this.shopList.map(item => item.id)
      const selectedIds = selection.map(item => item.id)
      this.tempSelected = this.tempSelected.filter(id => !currentIds.includes(id))
      selectedIds.forEach(id => {
        if (!this.tempSelected.includes(id)) {
          this.tempSelected.push(id)
        }
      })
      // 已选门店行信息（含跨页保留的行），供确认后回传父组件展示名称
      const rowMap = {}
      selection.forEach(row => {
        rowMap[row.id] = row
      })
      this.selectedShops = Object.keys(rowMap).map(id => rowMap[id])
    },
    async handleConfirm() {
      if (this.tempSelected.length === 0) {
        this.$message.warning('请至少选择一家门店')
        return
      }
      // 合并“选择门店”页勾选行 与 “批量上传”页解析行 的名称信息，按门店 ID 去重，
      // 保证批量解析 + 单独勾选的门店都能带名称回传，确认后立即显示、无需重新进入页面
      const rowMap = {}
      this.selectedShops.forEach(r => {
        if (r && r.id != null) rowMap[r.id] = r
      })
      if (this.uploadResult.shopIds && this.uploadResult.shopIds.length) {
        this.uploadResult.shopIds.forEach((id, i) => {
          if (!rowMap[id]) {
            rowMap[id] = {
              id,
              storename: (this.uploadResult.shopNames && this.uploadResult.shopNames[i]) || ('门店' + id)
            }
          }
        })
      }
      const rows = this.tempSelected.map(id => rowMap[id] || { id })
      this.$emit('confirm', [...this.tempSelected], rows)
      this.visible = false
    },
    handleClose() {
      this.$emit('close')
    },
    downloadTemplate() {
      const header = ['门店序号', '店铺名字']
      const rows = [[header], [['1', '示例门店']]]
      const csvContent = rows.map(e => e.join(',')).join('\n')
      const blob = new Blob(['\ufeff' + csvContent], { type: 'text/csv;charset=utf-8;' })
      const link = document.createElement('a')
      link.href = URL.createObjectURL(blob)
      link.download = '门店导入模板.csv'
      link.click()
    },
    // 选择/替换文件：仅记录文件，不自动解析（解析由“点击上传”按钮触发，便于在校验不通过时置灰按钮）
    handleFileChange(file, fileList) {
      this.fileList = fileList.slice(-1)
      // 重新选择文件后清空上一次的解析结果，避免旧的错误/数量残留影响按钮置灰判断
      this.uploadResult = { errors: [], shopIds: [], shopNames: [] }
    },
    // 超过上传数量限制（一次只能传一个表格）
    handleFileExceed() {
      this.$message.warning('一次只能上传一个表格')
    },
    // 点击上传：触发解析；校验（存在异常行）不通过时按钮为置灰态，不会走到这里
    async parseFile() {
      if (this.fileList.length === 0) {
        this.$message.warning('请先选择要上传的表格')
        return
      }
      const file = this.fileList[0]
      this.parsing = true
      const formData = new FormData()
      formData.append('file', file.raw)
      try {
        const res = await this.$http.post('/shopNotice/parseShopExcel', formData, {
          headers: { 'Content-Type': 'multipart/form-data' }
        })
        if (res.data.status === 0) {
          this.uploadResult = res.data.data
          if (this.uploadResult.success) {
            // 解析成功的门店合并进统一选择，支持“批量 + 单独添加”共存，底部数量随之更新
            const set = new Set(this.tempSelected)
            ;(this.uploadResult.shopIds || []).forEach(id => set.add(id))
            this.tempSelected = Array.from(set)
            this.$message.success(`解析成功，共${this.uploadResult.count}家门店`)
          } else {
            this.$message.error('Excel存在异常数据，请查看错误报告')
          }
        } else {
          this.$message.error(res.data.msg || '解析失败')
        }
      } catch (error) {
        console.error('解析Excel失败:', error)
        this.$message.error('解析Excel失败')
      } finally {
        this.parsing = false
      }
    },
    handleFileRemove() {
      this.fileList = []
      this.uploadResult = { errors: [], shopIds: [], shopNames: [] }
    },
    downloadErrorReport() {
      if (this.uploadResult.errors.length === 0) return
      const header = ['行号', '错误信息']
      const rows = [header, ...this.uploadResult.errors.map(item => [item.row, item.message])]
      const csvContent = rows.map(e => e.join(',')).join('\n')
      const blob = new Blob(['\ufeff' + csvContent], { type: 'text/csv;charset=utf-8;' })
      const link = document.createElement('a')
      link.href = URL.createObjectURL(blob)
      link.download = '错误报告.csv'
      link.click()
    }
  }
}
</script>

<style scoped>
.upload-submit-btn {
  margin-top: 12px;
}
.pagination-box {
  margin-top: 15px;
  text-align: right;
}
.upload-tip {
  margin-bottom: 15px;
}
.error-box {
  margin-top: 15px;
  padding: 10px;
  border: 1px solid #fde2e2;
  background: #fef0f0;
  border-radius: 4px;
  max-height: 200px;
  overflow-y: auto;
}
.error-title {
  display: flex;
  justify-content: space-between;
  margin-bottom: 8px;
  font-weight: bold;
  color: #f56c6c;
}
.error-item {
  color: #f56c6c;
  font-size: 12px;
  line-height: 1.8;
}
</style>
